var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-empty',{staticStyle:{"height":"100vh","width":"100vw"}},[_c('template',{slot:"image"},[_c('i',{staticClass:"el-icon-loading",staticStyle:{"font-size":"100px","color":"#ccc"}})]),_c('template',{slot:"description"},[_c('p',{staticStyle:{"font-size":"20px","color":"#999"}},[_vm._v("正在加载...")])])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }